import React from "react";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import { withStyles } from "@material-ui/core";

export const customTabMuiStyle = {
  "&:hover": {
    color: "#333f4c",
    opacity: 1,
  },
  "&": {
    color: "#1A273A",
    fontWeight: 600,
  },
};

export const CustomTabs = withStyles({
  root: {
    // borderBottom: '1px solid #1A273A',
    "& .MuiTab-wrapper": {
      fontFamily: "Mulish",
      fontStyle: "normal",
      fontWeight: "bold",
      fontSize: "15px",
      lineHeight: "30px",
      marginBottom: "-10px",
    },
  },
  indicator: {
    backgroundColor: "#1A273A",
    "& > span": {
      maxWidth: "40px !important",
      width: "100%",
      backgroundColor: "#635ee7",
    },
  },
})(Tabs);

export const CustomTab = withStyles((theme) => ({
  root: {
    textTransform: "none",
    minWidth: "auto",
    padding: "0rem",
    fontWeight: theme.typography.fontWeightRegular,
    marginRight: `10px`,
    color: "#808080",
    "&:hover": {
      color: "#333f4c",
      opacity: 1,
      padding: "0rem",
    },
    "&$selected": {
      color: "#000000",
      fontWeight: 600,
      fontFamily: "Mulish",
      fontStyle: "normal",
      fontWeight: "bold",
      fontSize: "24px",
      lineHeight: "30px",
      padding: "0rem",
    },
  },
  selected: {},
}))((props) => <Tab disableRipple {...props} />);
